import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

import { MamStatus } from '../../../domain/mam-explorer';
import { STATUS_OPTIONS, FilterOption } from '../mam-explorer.constants';

@Component({
  selector: 'evrideo-mam-explorer-toolbar',
  templateUrl: './mam-explorer-toolbar.component.html',
  styleUrls: ['./mam-explorer-toolbar.component.scss'],
})
export class MamExplorerToolbarComponent implements OnInit, OnDestroy {
  @Input() searchQuery = '';
  @Input() statusFilter: MamStatus | 'All' = 'All';

  @Output() searchChange = new EventEmitter<string>();
  @Output() statusFilterChange = new EventEmitter<MamStatus | 'All'>();
  @Output() uploadClick = new EventEmitter<void>();
  @Output() exportClick = new EventEmitter<void>();

  readonly statusOptions: FilterOption<MamStatus>[] = STATUS_OPTIONS;

  localSearch = '';
  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.localSearch = this.searchQuery;
    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$),
    ).subscribe(value => this.searchChange.emit(value));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSearchInput(value: string): void {
    this.localSearch = value;
    this.searchSubject.next(value);
  }

  onSearchKeypress(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.searchChange.emit(this.localSearch);
    }
  }

  onStatusChange(value: string): void {
    this.statusFilterChange.emit(value as MamStatus | 'All');
  }
}
